import React from 'react';
import { PrinterIcon, ScissorsIcon, HeartHandshakeIcon } from 'lucide-react';
import { steps } from '../data/content';
import { SectionHeading } from './SectionHeading';
const visuals = [{
  Icon: PrinterIcon,
  tone: 'bg-gold-wash text-gold-deep'
}, {
  Icon: ScissorsIcon,
  tone: 'bg-coral-wash text-coral-deep'
}, {
  Icon: HeartHandshakeIcon,
  tone: 'bg-leaf-wash text-leaf-deep'
}];
export function HowItWorks() {
  return <section aria-labelledby="how-title" className="bg-paper" data-id="element-181" data-mp="lll20qz9rdue">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-182" data-mp="qjwdt794jyf9">
        <SectionHeading id="how-title" title="Sharing the Gospel Can Start With 3 Simple Steps" data-id="element-183" data-mp="ql7jjcm4rg90" />
        <ol className="relative mt-16 grid gap-12 md:grid-cols-3 md:gap-8" data-id="element-184" data-mp="cq5bojxq3gtk">
          <span className="absolute left-[16.6%] right-[16.6%] top-12 hidden border-t-2 border-dashed border-cream-line md:block" aria-hidden="true" data-id="element-185" data-mp="grqok5a9bv3r" />
          {steps.map((step, i) => {
          const {
            Icon,
            tone
          } = visuals[i];
          return <li key={step.title} className="relative flex flex-col items-center text-center" data-id="element-186" data-mp="2rkwf52nucjp0" data-mpi={i}>
                <span className={`relative flex h-24 w-24 items-center justify-center rounded-full ring-8 ring-paper ${tone}`} data-id="element-187" data-mp="2mncot4dvcggp">
                  <Icon className="h-10 w-10" strokeWidth={1.75} aria-hidden="true" data-id="element-188" data-mp="31d24s5qmep11" />
                  <span className="absolute -right-1 -top-1 flex h-8 w-8 items-center justify-center rounded-full bg-navy text-sm font-extrabold text-white" data-id="element-189" data-mp="2wjppwnbqtwlh">
                    {i + 1}
                  </span>
                </span>
                <h3 className="mt-6 text-2xl font-extrabold uppercase tracking-[0.12em] text-navy" data-id="element-190" data-mp="36cn4iidm71et">{step.title}</h3>
                <p className="mt-3 max-w-[20rem] text-base leading-relaxed text-ink-soft" data-id="element-191" data-mp="3fb8ugylf1ipm">{step.text}</p>
                {step.extras && <ul className="mt-4 max-w-[20rem] space-y-1" data-id="element-192" data-mp="1pxdhfd9gfnzp">
                    {step.extras.map(e => <li key={e} className="text-[15px] font-bold text-navy" data-id="element-193" data-mp="1kyixu93nxvej">
                        {e}
                      </li>)}
                  </ul>}
              </li>;
        })}
        </ol>
      </div>
    </section>;
}